// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistant_head_deliveryterms1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery terms`)
};

const en_us2_assistant_head_deliveryterms1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery terms`)
};

const de_de2_assistant_head_deliveryterms1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lief.-Bed.`)
};

const en_assistant_head_deliveryterms1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery terms`)
};

const de_assistant_head_deliveryterms1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lief.-Bed.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistant_head_deliveryterms1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistant_head_deliveryterms1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistant_head_deliveryterms1", locale)
	if (locale === "en-GB") return en_gb2_assistant_head_deliveryterms1(inputs)
	if (locale === "en-US") return en_us2_assistant_head_deliveryterms1(inputs)
	if (locale === "de-DE") return de_de2_assistant_head_deliveryterms1(inputs)
	if (locale === "en") return en_assistant_head_deliveryterms1(inputs)
	return de_assistant_head_deliveryterms1(inputs)
};
export { assistant_head_deliveryterms1 as "assistant.head.deliveryTerms" }